// src/models/servicos/TipoEquipamento.js
export class TipoEquipamento {
  constructor(id = 0, descricao = '', ativo = true) {
    this.id = id;
    this.descricao = descricao;
    this.ativo = ativo;
  }
}
